<template>
	<div class="qw-image-uploader-source-picker-view">
		<qw-button
			v-for="sourceItem in pickerSources"
			:key="sourceItem.key"
			class="w-100"
			size="small"
			@click.stop="onSourceSelected(sourceItem)">
			{{sourceItem.value}}
		</qw-button>
	</div>
</template>

<script>
export default {
	name: "QwImageUploaderSourcePickerView",
	emits: ["sourceSelected"],

	props: {
		pickerSources: {type: Array, default: () => []},
	},

	methods: {
		onSourceSelected(sourceItem) {
			this.$emit("sourceSelected", sourceItem)
		},
	},
}
</script>

<style lang="scss">
.qw-image-uploader-source-picker-view {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: stretch;
	gap: 8px;
	padding: 12px;
	height: 100%;
	width: 100%;

	.el-button + .el-button {
		margin-left: 0;
	}
}
</style>
